/**
 * Phase Badge Component
 * Displays execution phase with appropriate styling
 */

import type { ExecutionPhase } from '../types'

interface PhaseBadgeProps {
  phase: ExecutionPhase | string | null
  size?: 'sm' | 'md'
}

const phaseConfig: Record<string, { icon: string; label: string }> = {
  ORCHESTRATION: {
    icon: '🎯',
    label: 'Orchestration',
  },
  AUDIENCE_REQUESTED: {
    icon: '📡',
    label: 'Audience Requested',
  },
  AUDIENCE_LOADING: {
    icon: '👥',
    label: 'Loading Audience',
  },
  CONTENT_GENERATION: {
    icon: '✍️',
    label: 'Generating Content',
  },
  DELIVERY: {
    icon: '🚀',
    label: 'Delivering',
  },
  FINALIZATION: {
    icon: '✅',
    label: 'Finalizing',
  },
}

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
}

export function PhaseBadge({ phase, size = 'md' }: PhaseBadgeProps) {
  if (!phase) {
    return (
      <span className={`inline-flex items-center gap-1 text-gray-400 ${sizeClasses[size]}`}>
        —
      </span>
    )
  }

  const config = phaseConfig[phase] || {
    icon: '⚙️',
    label: phase.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()),
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-gray-100 text-gray-700 font-medium ${sizeClasses[size]}`}
    >
      <span>{config.icon}</span>
      {config.label}
    </span>
  )
}

export default PhaseBadge
